module.exports = __webpack_public_path__ + "static/media/eu.3b2b6a4b.png";